// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.proofofinsurance.ProofOfInsuranceStatusType

export enum ProofOfInsuranceStatusType {
  EXPIRED = 'EXPIRED',
  NOT_REQUESTED = 'NOT_REQUESTED',
  REQUESTED = 'REQUESTED',
  SHARED = 'SHARED',
}

export const ProofOfInsuranceStatusType_values = [
  ProofOfInsuranceStatusType.EXPIRED,
  ProofOfInsuranceStatusType.NOT_REQUESTED,
  ProofOfInsuranceStatusType.REQUESTED,
  ProofOfInsuranceStatusType.SHARED,
] as const;
